// Cluster 02-A — FG21/1 vulnerability assessment (badge, section, form).
export default {
  sectionTitle: 'Vulnerability Assessment',
  badge: {
    vulnerable: 'Vulnerable — recorded',
    notVulnerable: 'Vulnerability assessed',
    noneRecorded: 'No vulnerability recorded',
    // Tier 3b — provenance chip beside the status badge: was this determination
    // AI-assisted (then confirmed by a named adviser) or adviser-recorded?
    provenanceAi: 'AI-assisted',
    provenanceAdviser: 'Adviser',
    // Surface A — reassessment reminder. Shown when a recorded determination is
    // older than the review interval (interim: 12 months, computed FE-side).
    reviewDue: 'Review due',
    reviewDueTooltip:
      'This assessment is over 12 months old. Review it to confirm their circumstances are unchanged (FG21/1 / Consumer Duty).',
  },
  form: {
    vulnerable: 'Client shows characteristics of vulnerability (FG21/1)',
    driversTitle: 'Drivers of vulnerability',
    drivers: {
      health: 'Health — conditions or illnesses that affect day-to-day ability',
      life_events: 'Life events — e.g. bereavement, job loss, relationship breakdown',
      resilience: 'Resilience — low ability to withstand financial or emotional shocks',
      capability: 'Capability — low knowledge or confidence in financial matters',
    },
    notes: 'Notes (optional)',
    save: 'Record assessment',
    saved: 'Vulnerability assessment recorded.',
    recordedBy: 'Recorded {when}',
  },
  history: {
    title: 'Assessment history',
    empty: 'No vulnerability assessment has been recorded for this case yet.',
    // Click-to-expand insights (the audit trail) for each recorded assessment.
    provenanceAi: 'AI-assisted',
    provenanceAdviser: 'Adviser',
    recordedOn: 'Recorded by an adviser {when}',
    confirmedOn: 'AI-suggested, confirmed by a named adviser {when}',
    dateUnknown: 'date not recorded',
    driversTitle: 'Drivers flagged',
    noDrivers: 'No specific drivers were flagged.',
    evidenceTitle: 'Evidence the AI cited',
    model: 'Generated by {model}',
  },
  aiScan: {
    run: 'Run AI vulnerability scan',
    runCaption:
      'Reads the client meeting notes and suggests a vulnerability assessment for you to review. Nothing is recorded until you confirm it.',
    scanning: 'Scanning meeting notes for signs of vulnerability…',
    timedOut:
      'The scan did not return a suggestion. You can run it again, or record the assessment manually below.',
    draftTitle: 'AI-suggested assessment',
    draftBadge: 'Draft — not yet confirmed',
    verdictVulnerable: 'Suggests the client shows characteristics of vulnerability (FG21/1).',
    verdictNotVulnerable: 'Suggests no characteristics of vulnerability were found.',
    complianceNotice:
      'This is a machine suggestion, not a decision. Nothing has been recorded or sent to the client. A named adviser must review and confirm it before it counts.',
    confirm: 'Confirm assessment',
    confirmCaption: 'Confirming records this against your name and lets the case proceed.',
    confirmed: 'Vulnerability assessment confirmed.',
    provenance: 'Generated by {model}.',
  },
};
